var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#FFF5F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.5 30.0822C54.5 31.5527 53.8002 39.1192 52.6279 46.4036C52.0448 50.0276 51.3643 53.4526 50.6323 55.9341C50.5878 56.0848 50.5437 56.2301 50.5 56.37C50.4563 56.2301 50.4122 56.0848 50.3677 55.9341C49.6357 53.4526 48.9552 50.0276 48.3721 46.4036C47.1998 39.1192 46.5 31.5527 46.5 30.0822C46.5 28.2577 48.1318 26.5 50.5 26.5C52.8682 26.5 54.5 28.2577 54.5 30.0822ZM57 30.0822C57 33.4413 54.0899 61 50.5 61C46.9101 61 44 33.4413 44 30.0822C44 26.7231 46.9101 24 50.5 24C54.0899 24 57 26.7231 57 30.0822ZM54.5 70C54.5 71.933 52.933 73.5 51 73.5C49.067 73.5 47.5 71.933 47.5 70C47.5 68.067 49.067 66.5 51 66.5C52.933 66.5 54.5 68.067 54.5 70ZM57 70C57 73.3137 54.3137 76 51 76C47.6863 76 45 73.3137 45 70C45 66.6863 47.6863 64 51 64C54.3137 64 57 66.6863 57 70Z",
    fill: "#FFCD4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/Icon.cc6cb9332cef2c295e3da1973ef123da.svg";
export { ForwardRef as ReactComponent };